import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useRef, useState } from "react";
import ReactImageMagnify from "react-image-magnify";
import { css } from "styled-components";

export interface ImageMagnifyZoomInferface {
    container?: InjectableCss;
}

const magnifyStyles: ImageMagnifyZoomInferface = {
    container: {
        css: css`
            .enlarged-image-container {
                width: 100% !important;
                position: relative;
                background-color: ${getColor("common.backgroundContrast")};
            }
        `,
    },
};

const styles = magnifyStyles;

export default function ImageMagnifyZoom({ imagePath, largeImagePath, imageAlt }: { imagePath: string; largeImagePath: string; imageAlt: string; }) {
    const [smallImgWidth, setSmallImgWidth] = useState(0);
    const [smallImgHeight, setSmallImgHeight] = useState(0);
    const [enlargedImgWidth, setEnlargedImgWidth] = useState(0);
    const [enlargedImgHeight, setEnlargedImgHeight] = useState(0);
    const imgContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (smallImgWidth && smallImgHeight) {
            setEnlargedImgHeight(smallImgHeight * 3);
            setEnlargedImgWidth(smallImgWidth * 3);
        }
    }, [smallImgWidth, smallImgHeight]);

    // const [loadedImage, setLoadedImage] = useState<HTMLImageElement | null>(null);

    // useEffect(() => {
    //     const image = new Image();
    //     image.onload = () => {
    //         setLoadedImage(image);
    //     };
    //     image.src = largeImagePath;
    // }, [largeImagePath]);

    const onImageLoad = () => {
        const children = imgContainerRef?.current?.children;
        const smallImg = imgContainerRef?.current?.getElementsByTagName("img")[0];

        if (children && smallImg) {
            setSmallImgWidth(smallImg.getBoundingClientRect().width);
            setSmallImgHeight(smallImg.getBoundingClientRect().height);
        }
    };

    return (
        <StyledWrapper ref={imgContainerRef} {...styles.container}>
            <ReactImageMagnify
                enlargedImageContainerDimensions={{
                    width: 600,
                    height: "100%",
                }}
                {...{
                    smallImage: {
                        alt: imageAlt,
                        isFluidWidth: true,
                        src: imagePath,
                        onLoad: () => onImageLoad(),
                    },
                    largeImage: {
                        alt:imageAlt,
                        src: largeImagePath,
                        width: enlargedImgWidth,
                        height: enlargedImgHeight,
                    },
                    shouldUsePositiveSpaceLens: true,
                    imageClassName: "smallImage",
                    enlargedImageContainerClassName: "enlarged-image-container",
                    hoverDelayInMs: 0,
                }}
            />
        </StyledWrapper>
    );
}
